class PendingOrdersController {
    static $inject = ["$location", "stToast", "tpsrService"];

    constructor($location, stToast, tpsrService) {
        this.$location = $location;
        this.toast = stToast;
        this.tpsr = tpsrService;

        this.orders = [];
        this.paging = {
            size: 100,
            number: 1,
            totalQty: 0,
            orderBy: "create_date",
            orderDescending: false
        };
    }

    $onInit() {
        return this._loadOrders();
    }

    prevPageClicked = () => {
        this.paging.number--;
        return this._loadOrders();
    };

    nextPageClicked = () => {
        this.paging.number++;
        return this._loadOrders();
    };

    detailsClicked = order => {
        this.$location.url(`/orders/${order.order_id}?ref=pending`);
    };

    backToUsersClicked = () => {
        this.$location.url(`/users`);
    };

    approveClicked = order => {
        return this.tpsr.approveOrder(order.order_id).then(result => {
            if (result.success) {
                this.toast.success("Order Approved", `Order approved.`)
                this._loadOrders();
            }
        });
    };

    rejectClicked = order => {
        return this.tpsr.rejectOrder(order.order_id).then(result => {
            if (result.success) {
                this.toast.success("Order Rejected", `Order rejected.`)
                this._loadOrders();
            }
        });
    }

    _loadOrders = () => {
        return this.tpsr.getOrdersPending(this.paging.size, this.paging.number, this.paging.orderBy, this.paging.orderDescending, this.managerId)
            .then(result => {
                this.orders = result.orders;
                this.paging.totalQty = result.totalQty;
            });
    };
}

angular
    .module("app")
    .component("pendingOrders", { // pending-orders
        bindings: {
            managerId: "<"
        },
        templateUrl: "src/app/pendingOrders/pendingOrders.html",
        controller: PendingOrdersController
    });
